<template>

  <b-col>
    <h1>Статистика</h1>

    <b-nav tabs class="mb-2">
      <b-nav-item :to="{name: 'statistics-overview', params: {projectId: this.projectId}}" exact exact-active-class="active" >
        <fa-icon icon="chart-bar" /> Обзор
      </b-nav-item>
      <b-nav-item :to="{name: 'statistics-incoming', params: {projectId: this.projectId}}" exact exact-active-class="active" >
        <fa-icon icon="arrow-left" /> Входящие
      </b-nav-item>
      <b-nav-item :to="{name: 'statistics-outgoing', params: {projectId: this.projectId}}" exact exact-active-class="active" >
        <fa-icon icon="arrow-right" /> Исходящие
      </b-nav-item>
    </b-nav>    

    <router-view></router-view>

  </b-col>

</template>

<script>
export default {
    name: 'StatisticsMain',
    props: [
        'projectId',
    ],
};
</script>
